import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Container, Row, Col, Table, Image } from "react-bootstrap";
import "./Wallet.css";
import { fetchWalletDetailsStart } from "../../store/actions/WalletAction";
import { fetchAllTransactionStart } from "../../store/actions/TransactionAction";
import WithdrawModal from "../helper/WithdrawModal";
import NoDataFound from "../NoDataFound/NoDataFound";
import WalletLoader from "../Loader/WalletLoader";
import { t } from "react-multi-lang";

const Wallet = (props) => {
	useEffect(() => {
		props.dispatch(fetchWalletDetailsStart());
		props.dispatch(fetchAllTransactionStart());
	}, []);

	const [withdrawModal, setWithdrawModal] = useState(false);

	const closeWithdrawModal = () => {
		setWithdrawModal(false);
	};

	return (
		<>
			<div className="wallet-sec">
				{props.wallet.loading ? (
					<WalletLoader></WalletLoader>
				) : (
					<Container>
						<Row>
							<Col sm={12} md={12}>
								<div className="wallet-header-sec">
									<Row>
										<Col sm={12} md={6} xl={5}>
											<div className="wallet-header-card">
												<h5>{t("total_earnings")}</h5>
												<div className="wallet-header-details">
													<Image
														src={
															window.location.origin +
															"/assets/images/icons/wallet-active.svg"
														}
														className="credit-img"
													/>
													<h3>
														{props.wallet.data.user_wallet.total_formatted}
														{/* <span className="amount-decimal">.76500293</span> */}
														{/* <span className="amount-abb">..</span> */}
													</h3>
												</div>
											</div>
										</Col>
										<Col sm={12} md={6} xl={4}>
											<div className="wallet-header-card">
												<h5>{t("current_balance")}</h5>
												<div className="wallet-header-details">
													<Image
														src={
															window.location.origin +
															"/assets/images/icons/wallet-dollar.svg"
														}
														className="credit-img"
													/>
													<h3>
														{props.wallet.data.user_wallet.remaining_formatted}
														{/* <span className="amount-decimal">.76500293</span>
														<span className="amount-abb">BTC</span> */}
													</h3>
												</div>
											</div>
										</Col>
										<Col sm={12} md={12} xl={3}>
											<div className="edit-save">
												<Button
													className="send-btn-white"
													onClick={() => setWithdrawModal(true)}
												>
													{t("withDraw")}
												</Button>
											</div>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</Container>
				)}
			</div>
			<div className="wallet-trans-table">
				<Container>
					<Row>
						<Col sm={12} md={12}>
							<h4>{t("transactions")}</h4>
							<div className="trans-table">
								<Table borderedless responsive>
									{props.transaction?.data?.history?.length > 0 && (<thead>
										<th>Id</th>
										<th>Amount</th>
										<th>Payout Method</th>
										<th>Status</th>
										<th>Requested Date</th>
									</thead>)}

									<tbody>
										{props.transaction.loading ? (
											t("loading")
										) : props.transaction.data.history.length > 0 ? (
											props.transaction.data.history.map((data, index) => (
												<tr>
													<td className="amount">{index + 1}</td>
													<td className="amount">
														{data.requested_amount_formatted}{" "}
													</td>
													<td className="amount">
														Bank
													</td>

													<td className="amount">
														{data.status_formatted == "Sent" ? "Pending" : data.status_formatted}
													</td>
													<td className="amount">
														{data.req_date_formatted}{" "}
													</td>

												</tr>
											))
										) : (
											<NoDataFound></NoDataFound>
										)}
									</tbody>
								</Table>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
			<WithdrawModal
				withdrawModal={withdrawModal}
				closeWithdrawModal={closeWithdrawModal}
				payments={props.wallet}
			/>
		</>
	);
};

const mapStateToPros = (state) => ({
	wallet: state.wallet.walletData,
	transaction: state.transaction.allTransaction,
});

function mapDispatchToProps(dispatch) {
	return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Wallet);